export const REQUIRED_STATEMENT = 'Obrigatório'
export const INVALID_STATEMENT = 'Inválido'

export const ID_ISSUING_ENTITIES = [
  { label: "Secretaria de Segurança Pública", value: "SSP" },
  { label: "Cartório Civil", value: "CARTORIO" },
  { label: "Polícia Federal", value: "DPF" },
  { label: "Departamento de Trânsito (Detran)", value: "DETRAN" },
  { label: "Academia Brasileira de Neurocirurgia", value: "ABNC" },
  { label: "Coordenação Geral de Polícia de Imigração da Polícia Federal", value: "CGPI/DUREX/DPF" },
  { label: "Coordenação Geral de Privilégios e Imunidades", value: "CGPI" },
  { label: "Coordenadoria Geral de Polícia Marítima, Aeronáutica e de Fronteiras", value: "CGPMAF" },
  { label: "Conselho Nacional de Imigração", value: "CNIG" },
  { label: "Carteira Nacional de Habilitação", value: "CNH" },
  { label: "Conselho Regional de Enfermagem", value: "COREN" },
  { label: "Conselho Regional de Economia", value: "CORECON" },
  { label: "Conselho Regional de Administração", value: "CRA" },
  { label: "Centro de Referência de Assistência Social", value: "CRAS" },
  { label: "Conselho Regional de Biblioteconomia", value: "CRB" },
  { label: "Conselho Regional de Contabilidade", value: "CRC" },
  { label: "Conselho Regional de Estatística", value: "CRE" },
  { label: "Conselho Regional de Engenharia, Arquitetura e Agronomia", value: "CREA" },
  { label: "Conselho Regional de Corretores Imóveis", value: "CRECI" },
  { label: "Conselho Regional de Fisioterapia e Terapia Ocupacional", value: "CREFIT" },
  { label: "Conselho Regional de Serviço Social", value: "CRESS" },
  { label: "Conselho Regional de Farmácia", value: "CRF" },
  { label: "Conselho Regional de Medicina", value: "CRM" },
  { label: "Conselho Regional de Nutrição", value: "CRN" },
  { label: "Conselho Regional de Odontologia", value: "CRO" },
  { label: "Conselho Regional de Psicologia", value: "CRP" },
  { label: "Conselho Regional de Profissionais de Relações Públicas", value: "CRPRE" },
  { label: "Conselho Regional de Química", value: "CRQ" },
  { label: "Conselho Regional de Representantes Comerciais", value: "CRRC" },
  { label: "Conselho Regional de Medicina Veterinária", value: "CRMV" },
  { label: "Carteira Sede Carpina de Pernambuco", value: "CSC" },
  { label: "Carteira de Trabalho e Previdência Social", value: "CTPS" },
  { label: "Diretoria de Identificação Civil", value: "DIC" },
  { label: "Diretoria Executiva", value: "DIREX" },
  { label: "Divisão de Polícia Marítima, Área e de Fronteiras", value: "DPMAF" },
  { label: "Departamento de Polícia Técnica Geral", value: "DPT" },
  { label: "Programa Municipal DST/Aids", value: "DST" },
  { label: "Fundo de Garantia do Tempo de Serviço", value: "FGTS" },
  { label: "Fundação Instituto de Pesquisas Econômicas", value: "FIPE" },
  { label: "Fundação Lyndolpho Silva", value: "FLS" },
  { label: "Governo do Estado de Goiás", value: "GOVGO" },
  { label: "Carteira de Identidade Classista", value: "I CLA" },
  { label: "Instituto Félix Pacheco", value: "IFP" },
  { label: "Instituto Geral de Perícias", value: "IGP" },
  { label: "Instituto de Identificação Civil e Criminal Engrácia da Costa Francisco de Rondônia", value: "IICCECF/RO" },
  { label: "Grupo de Monitoramento Interinstitucional", value: "IIMG" },
  { label: "Instituto Médico-Legal", value: "IML" },
  { label: "Índice de Preços ao Consumidor", value: "IPC" },
  { label: "Instituto Pereira Faustino", value: "IPF" },
  { label: "Comando da Aeronáutica", value: "COMAER" },
  { label: "Exército Brasileiro", value: "EB" },
  { label: "Marinha do Brasil", value: "MB" },
  { label: "Ordem dos Músicos do Brasil", value: "OMB" },
  { label: "Ordem dos Advogados do Brasil", value: "OAB" },
  { label: "Policia Civil do Estado de Minas Gerais", value: "PCMG" },
  { label: "Polícia Militar do Estado de Minas Gerais", value: "PMMG" },
  { label: "Polícia Militar", value: "PM" },
  { label: "Secretaria de Defesa Social (Pernambuco)", value: "SDS" },
  { label: "Secretaria Nacional de Justiça / Departamento de Estrangeiros", value: "SNJ" },
  { label: "Secretaria de Estado da Casa Civil", value: "SECC" },
  { label: "Secretaria de Estado de Justiça e Segurança Pública – Mato Grosso", value: "SEJUSP" },
  { label: "Carteira de Estrangeiro", value: "EST" },
  { label: "Secretaria de Estado da Segurança Pública do Paraná", value: "SESP" },
  { label: "Secretaria da Justiça e Segurança", value: "SJS" },
  { label: "Secretaria da Justiça do Trabalho e Cidadania", value: "SJTC" },
  { label: "Secretaria da Justiça do Trabalho e Segurança", value: "SJTS" },
  { label: "Secretaria de Polícia Técnico-Científica", value: "SPTC" },
  { label: "Organismos Militares", value: "MILITAR" },
  { label: "Outros Emissores", value: "OUTROS" },
  { label: "Documento Estrangeiro", value: "ESTRANGEIRO" },
]

export const FEDERATIVE_UNITIES = [
  {label: "Acre", value: "AC"},
  {label: "Alagoas", value: "AL"},
  {label: "Amapá", value: "AP"},
  {label: "Amazonas", value: "AM"},
  {label: "Bahia", value: "BA"},
  {label: "Ceará", value: "CE"},
  {label: "Distrito Federal", value: "DF"},
  {label: "Espírito Santo", value: "ES"},
  {label: "Goiás", value: "GO"},
  {label: "Maranhão", value: "MA"},
  {label: "Mato Grosso", value: "MT"},
  {label: "Mato Grosso do Sul", value: "MS"},
  {label: "Minas Gerais", value: "MG"},
  {label: "Pará", value: "PA"},
  {label: "Paraíba", value: "PB"},
  {label: "Paraná", value: "PR"},
  {label: "Pernambuco", value: "PE"},
  {label: "Piauí", value: "PI"},
  {label: "Rio de Janeiro", value: "RJ"},
  {label: "Rio Grande do Norte", value: "RN"},
  {label: "Rio Grande do Sul", value: "RS"},
  {label: "Rondônia", value: "RO"},
  {label: "Roraima", value: "RR"},
  {label: "Santa Catarina", value: "SC"},
  {label: "São Paulo", value: "SP"},
  {label: "Sergipe", value: "SE"},
  {label: "Tocantins", value: "TO"}
]

export const ESTBLISHMENT_FORMATS = [
  {label: "Empreendedor Individual", value: "EI"},
  {label: "Micro Empreendedor Individual", value: "MEI"},
  {label: "Micro Empresa", value: "ME"},
  {label: "Empresa Individual de Responsabilidade Limitada", value: "EIRELI"},
  {label: "Limitada", value: "LTDA"},
  {label: "Sociedade Simples", value: "SS"},
  {label: "Sociedade Anônima", value: "SA"},
  {label: "Empresa de Pequeno Porte", value: "EPP"},
  {label: "Empresas de Médio e Grande Porte", value: "EMGP"},
  {label: "Cooperativa", value: "COOP"}
]

export const COMPANY_DOCUMENT_TYPES = [
  {label: "Comprovante de MEI", value: "CCMEI"},
  {label: "Contrato Social", value: "ARTICLES_OF_ASSOCIATION"},
  {label: "Estatuto Social", value: "COMPANY_BYLAWS"},
  {label: "Requerimento de Empresário Individual", value: "EI_REGISTRATION_REQUIREMENT"},
  {label: "Ato Constitutivo de EIRELI", value: "EIRELI_INCORPORATION_STATEMENT"},
]

export const ATTORNEY_DOCUMENT_TYPES = [
  {label: "Requerimento de Empresário Individual", value: "PUBLIC_LETTER_OF_ATTORNEY"},
  {label: "Carta de Procuração Particular", value: "PRIVATE_LETTER_OF_ATTORNEY"},
  {label: "Carta de Procuração Pública", value: "PRIVATE_LETTER_OF_ATTORNEY"},
]

export const ADDITIONAL_DOCUMENT_TYPES = [
  {label: "Comprovante de faturamento", value: "REVENUES_RECEIPT"},
  {label: "Carteira de identidade profissional", value: "PROFESSIONAL_IDENTIFICATION_CARD"},
  {label: "Carteira de identidade Militar", value: "MILITARY_IDENTIFICATION_CARD"},
  {label: "Cartão Assinatura", value: "SIGNATURE_CARD"},
  {label: 'Declaração Legal', value: 'LEGAL_STATEMENT'},
  {label: 'Declaração de beneficiários finais', value: 'DECLARATION_OF_FINAL_BENEFICIARIES'},
]
